import { render, staticRenderFns } from "./BaseSelectOptions.vue?vue&type=template&id=54e1c98a&scoped=true"
import script from "./BaseSelectOptions.vue?vue&type=script&lang=js"
export * from "./BaseSelectOptions.vue?vue&type=script&lang=js"
import style0 from "./BaseSelectOptions.vue?vue&type=style&index=0&id=54e1c98a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "54e1c98a",
  null
  
)

export default component.exports